var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3839_4630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 65.5C46.1617 65.5 47.1354 65.1071 47.9213 64.3213C48.7071 63.5354 49.1 62.5617 49.1 61.4C49.1 60.2383 48.7071 59.2646 47.9213 58.4788C47.1354 57.6929 46.1617 57.3 45 57.3C43.8383 57.3 42.8646 57.6929 42.0788 58.4788C41.2929 59.2646 40.9 60.2383 40.9 61.4C40.9 62.5617 41.2929 63.5354 42.0788 64.3213C42.8646 65.1071 43.8383 65.5 45 65.5ZM40.9 49.1H49.1V24.5H40.9V49.1ZM45 86C39.3283 86 33.9983 84.9237 29.01 82.7712C24.0217 80.6187 19.6825 77.6975 15.9925 74.0075C12.3025 70.3175 9.38125 65.9783 7.22875 60.99C5.07625 56.0017 4 50.6717 4 45C4 39.3283 5.07625 33.9983 7.22875 29.01C9.38125 24.0217 12.3025 19.6825 15.9925 15.9925C19.6825 12.3025 24.0217 9.38125 29.01 7.22875C33.9983 5.07625 39.3283 4 45 4C50.6717 4 56.0017 5.07625 60.99 7.22875C65.9783 9.38125 70.3175 12.3025 74.0075 15.9925C77.6975 19.6825 80.6187 24.0217 82.7712 29.01C84.9237 33.9983 86 39.3283 86 45C86 50.6717 84.9237 56.0017 82.7712 60.99C80.6187 65.9783 77.6975 70.3175 74.0075 74.0075C70.3175 77.6975 65.9783 80.6187 60.99 82.7712C56.0017 84.9237 50.6717 86 45 86Z",
    fill: "#F59A00"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3839_4630)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 44.5,
    stroke: "#F59A00",
    strokeDasharray: "2 2",
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3839_4630",
    x: -2.74275,
    y: -2.74275,
    width: 95.4855,
    height: 95.4855,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.37137
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.301961 0 0 0 0 0.815686 0 0 0 0 0.996078 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3839_4630"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3839_4630",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3839_4630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationRound);
export default __webpack_public_path__ + "static/media/ExclamationRound.9ce0e8878cb5bb79df079be7036f7ce0.svg";
export { ForwardRef as ReactComponent };